import { AgentConnectionState } from "@/hooks/useLiveKitAgent";
import { getUserFacingConnectionFailureMessage } from "@/lib/livekit-user-facing-messages";
import { motion } from "framer-motion";
import { AlertTriangle, RotateCw, Wifi, WifiOff } from "lucide-react";

interface ConnectionStatusProps {
  connectionState: AgentConnectionState;
  connectionError?: string | null;
  retryConnection?: () => void;
}

export function ConnectionStatus({
  connectionState,
  connectionError,
  retryConnection,
}: ConnectionStatusProps) {
  if (connectionState === "failed") {
    return (
      <div className="flex min-h-[50vh] w-full flex-col items-center justify-center gap-5 px-4">
        {/* Icon */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="flex h-14 w-14 items-center justify-center rounded-lg border border-red-400/25 bg-red-400/10"
        >
          <WifiOff size={26} className="text-red-400" />
        </motion.div>

        {/* Copy */}
        <div className="text-center space-y-2 max-w-sm">
          <div className="flex items-center justify-center gap-2 text-gray-100 text-lg font-semibold">
            <AlertTriangle size={18} className="text-red-400 shrink-0" />
            We couldn't continue the session
          </div>
          <p className="text-sm text-gray-400 leading-relaxed">
            {getUserFacingConnectionFailureMessage(connectionError)}
          </p>
        </div>

        {/* Retry */}
        {retryConnection && (
          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            onClick={retryConnection}
            className="flex h-11 items-center gap-2 rounded-md bg-[#FD954F] px-5 text-sm font-semibold text-[#1C1C1E] transition-colors hover:bg-[#F28747]"
          >
            <RotateCw size={16} />
            Try again
          </motion.button>
        )}
      </div>
    );
  }

  return null;
}
